import { observable, action, runInAction, toJS } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import consola from 'consola';
import URI from 'urijs';
import Cookies from 'js-cookie';

import moUser from '@store/user';
import moStore, { toggleLoading, toggleValue } from '@store/index';
import moLogin, { toggleLogin } from '@store/login';
import Service from '@service/index';
import HRService from '@service/hr';
import ResearchService from '@service/industry-research';
import { initUpRate } from '../human-indicator/up-rate/store';
import { initTimeTrend } from '../human-indicator/time-trend/store';
import { initCityRate } from '../human-indicator/city-rate/store';
import { initCategory } from '../human-indicator/category-type-rate/store';
import { initDetailRate } from '../human-indicator/detail-category-rate/store';
import { initLeaveRate, initLeaveRateTable } from '../human-indicator/leave-rate/store';
import { initLeave } from '../human-indicator/leave-rate-time-trend/store';
import { initFreshSalary } from '../human-indicator/fresh-salary/store';
import {
  initCategoryList, initYearList, initCityList, initCityArr, initFreshList,
} from '../human-indicator/category-fresh-salary/store';
import { initDifferent } from '../human-indicator/city-different/store';
import { getIndustryDistibution } from '../industry-research/industry-chain/store';
import { initTypicalPosition } from '../industry-research/typical-position/store';
import { initLocationDistribution } from '../industry-research/company-distribution/store';
import { getPropertyData, getScaleData } from '../industry-research/company-scale/store';
import { initIndustryReport } from '../industry-research/industry-report/store';
import { initMarketScale } from '../industry-research/market-scale/store';
import { demandInit } from '../human-demand/store/index';
import { talentFlowInit } from '../talent-flow/store/portrait';
import { mobilityInit } from '../talent-flow/store/mobility';
import { welfareInit } from '../wealfare-insight/store/wealfare';
import { initOverview, initUpdateTime } from '../top/top';
import { cityInit } from '../human-indicator/city-rate/city-store';
import { freshCityInit } from '../human-indicator/category-fresh-salary/city-store';
import moHotRole, { getTimeListTop } from '../human-demand/store/hotrole';
import moCity, { getCityTimeList } from '../human-demand/store/city';
import moCompany, { getCompanyRankTime } from '../human-demand/store/company';
import posthog from 'posthog-js';
import { useNavigate, useParams } from 'react-router-dom';

interface IItem {
  code: number | string,
  name: string,
}

const moIndex = observable({
  isLoading: false,
  // 无vip权限 弹框提示
  isVipTip: false,
  // 我所属行业
  industry: <IItem>{ code: '', name: '' },
  // 对比的行业
  compareIndustry: <any[]>[],
  // 基准城市
  baseCity: <IItem>{ code: '', name: '' },
  cityList: <any[]>[], // 基准城市 - 城市列表
  multiIndustry: <any[]>[], // 对比的行业 - 所有行业
  singleIndustry: <any[]>[], // 我所属行业 - 所有行业
  currentMulti: <any[]>[], // 对比的行业 - 当前行业
  currentSingle: <any>null, // 我所属行业 - 当前行业
  singleModal: false, // 我所属行业 - 弹框
  multiModal: false, // 对比的行业 - 弹框
  cityModal: false, // 基准城市 - 弹框
  // 城市涨薪率 -- 多选城市
  isCityRate: false,
  isCategoryCityRate: false,
  multiCity: <any[]>[],
  multiCityCopy: <any[]>[],
  multiCityListCopy: <any[]>[],
  multiCityList: <any[]>[],
  categoryCity: <any[]>[],
  categoryCityArr: <any[]>[],
  // 人力指标 - 离职率
  dismissionYear: <any[]>[], // 行业离职率 年份选项
  defaultDismissionYear: <number | string>'', // 行业离职率 默认年份
  // 行业应届生起薪
  freshYear: <number | string>'',
  freshYearList: <any[]>[],
  // 职能应届生起薪
  freshCategoryYear: <number | string>'',
  freshCategoryYearList: <any[]>[],
  // 城市薪酬差异系数
  cityDiffYear: <number | string>'',
  cityDiffYearList: <any[]>[],
  industryArr: <any[]>[],
  isMock: <boolean>false,
  isHidden: false,
});

// 获取用户筛选项信息
const requestUserOption = action(async () => {
  // console.log('------ 获取用户筛选项信息 ------');
  let currentSingle: any[] = [];
  let currentMulti: any[] = [];
  let baseCity: IItem = { code: '', name: '' };
  let myIndustry: IItem = { code: '', name: '' };
  let multiCity: any[] = [];
  let compareArr: any[] = [];
  let singleArr: any[] = cloneDeep(moIndex.singleIndustry);
  let multiArr: any[] = cloneDeep(moIndex.multiIndustry);
  let multiCityArr: any[] = cloneDeep(moIndex.multiCityList);
  let cityArr: any[] = cloneDeep(moIndex.cityList);
  let categoryCity: any[] = [];
  let categoryCityArr: any[] = cloneDeep(moIndex.cityList);
  let multiTag = false;

  // 获取筛选条件前，先初始化
  await HRService.initUserOption();

  const result: any = await HRService.getUserOption();
  // console.log('获取 user option -- ', result);
  if (isEmpty(result)) return;

  singleArr.map((item: any) => {
    item.sub_industries?.map((child: any) => {
      if (result.my_industry === child.name) {
        currentSingle = item;
        item.info.active = true;
        child.active = true;
        myIndustry.name = child.name;
        myIndustry.code = child.code;
      }
    });
  });

  // 对比的行业，高亮第一个行业(包含有已选行业的一级行业)
  // 对比的行业，当前行业为(第一个包含已选行业的一级行业)
  multiArr.map((item: any) => {
    item.sub_industries?.map((child: any) => {
      if (result.multi_industries?.includes(child.name)) {
        if (!multiTag) {
          item.info.active = true;
          multiTag = true;
          currentMulti = item.sub_industries;
        }
        child.active = true;
        compareArr.push({ code: child.code, name: child.name })
      }
    });
  });

  multiCityArr.map((item: any) => {
    if (result.multi_cities?.includes(item.name)) {
      item.active = true;
      multiCity.push({ code: item.code, name: item.name, active: false });
    }
  });

  categoryCityArr.map((item: any) => {
    if (result.multi_cities?.includes(item.name)) {
      item.active = true;
      categoryCity.push({ code: item.code, name: item.name, active: false, });
    }
  });

  cityArr.map((item: any) => {
    if (result.standard_city === item.name) {
      item.active = true;
      baseCity = { name: item.name, code: item.code };
    }
  });

  runInAction(() => {
    moIndex.industry = myIndustry;
    moIndex.compareIndustry = compareArr;
    moIndex.currentSingle = currentSingle;
    moIndex.currentMulti = currentMulti;
    moIndex.singleIndustry = singleArr;
    moIndex.multiIndustry = multiArr;
    moIndex.multiCity = multiCity;
    moIndex.multiCityList = multiCityArr;
    moIndex.categoryCity = categoryCity;
    moIndex.categoryCityArr = categoryCityArr;
    moIndex.cityList = cityArr;
    moIndex.baseCity = baseCity;
    moIndex.isMock = result.is_mock;
  });
});

// 获取 info 数据
const requestBase = action(async () => {
  const result: any = await Service.base();
  // console.log('获取 info --- ', result);
  let baseCityArr: any[] = [];
  let industryArr: any[] = [];
  let multiIndustryArr: any[] = [];

  if (isEmpty(result)) return;

  result.city?.map((item: any) => {
    if (!item.is_area_type && !item.is_city_type && (item.city_type !== '全国')) {
      baseCityArr.push({
        code: item.code,
        name: item.name,
        active: false,
        hover: false,
      });
    }
  });
  result.industry?.map((item: any) => {
    // if (item.info.name !== '全行业') {}
    industryArr.push({
      info: item.info,
      sub_industries: item.sub_industries,
    });
  });
  result.industry?.map((item: any) => {
    if (item.info.name !== '全行业') {
      multiIndustryArr.push({
        info: item.info,
        sub_industries: item.sub_industries,
      });
    }
  });
  industryArr.map((item: any) => {
    item.info.active = false;
    item.info.hover = false;
    item.sub_industries?.map((child: any) => {
      child.active = false;
      child.hover = false;
    });
  });
  multiIndustryArr.map((item: any) => {
    item.info.active = false;
    item.info.hover = false;
    item.sub_industries?.map((child: any) => {
      child.active = false;
      child.hover = false;
    });
  });

  cityInit(result.city);
  freshCityInit(result.city);

  runInAction(() => {
    // console.log('基准城市列表 -- ', baseCityArr);
    moIndex.cityList = cloneDeep(baseCityArr);
    moIndex.multiCityList = cloneDeep(baseCityArr);
    moIndex.singleIndustry = cloneDeep(industryArr);
    moIndex.multiIndustry = cloneDeep(multiIndustryArr);
    moIndex.industryArr = result.industry
  });
});

const researchRequest = action(async () => {
  console.log('++++++ 行业研究 初始化 ++++++');
  const { industry } = moIndex;
  const { code } = industry;

  let tempType = localStorage.getItem('distributionType') || '';
  if (!tempType) localStorage.setItem('distributionType', 'city');

  Promise.all([
    ResearchService.chainDistribution({ industry: code }),
    ResearchService.typicalJobs({ industry: code }),
    ResearchService.locationDistribution({ industry: code, type: 'city' }),
    ResearchService.natureDistribution({ industry: code }),
    ResearchService.scaleDistribution({ industry: code }),
    ResearchService.report(),
    ResearchService.marketSize({ industry: code }), // 4201001
  ]).then((res: any) => {
    if (isEmpty(res)) return;

    getIndustryDistibution(res[0]);
    initTypicalPosition(res[1]);
    initLocationDistribution(res[2]);
    getPropertyData(res[3]);
    getScaleData(res[4]);
    initIndustryReport(res[5]);
    initMarketScale(res[6]);

    setTimeout(() => {
      toggleLoading(false);
    }, 500);
  });
});

// 触发全局条件时，刷新接口请求
const requests = action(async (
  dismissionYear: number | string,
  freshYear: number | string,
  freshCategoryYear: number | string,
  cityDiffYear: number | string,
) => {
  const { industry } = moIndex;
  Promise.all([
    // +++ 涨薪率 +++
    HRService.upRateIndustry(),
    HRService.upRateIndustryTime(),
    HRService.upRateCity(),
    HRService.upRateCategoryType(),
    HRService.upRateCategoryDetail(),
    HRService.dimissionIndustry(dismissionYear),
    HRService.dismissionTimeTrend(),
    HRService.freshIndustry(freshYear),
    HRService.freshCategory(freshCategoryYear),
    HRService.yearFreshCategory(),
    HRService.cityFreshCategory(freshCategoryYear),
    HRService.cityDiff(cityDiffYear),
    // HRService.overview(industry.name),
    // +++ 涨薪率 +++
  ]).then((res: any) => {
    // console.log('promise all res --- ', res);
    if (isEmpty(res)) return;

    initUpRate(res[0]);
    initTimeTrend(res[1]);
    initCityRate(res[2]);
    initCategory(res[3]);
    initDetailRate(res[4]);
    initLeaveRate(res[5]);
    initLeave(res[6]);
    initFreshSalary(res[7]);
    initFreshList(res[8], res[10], res[9]);
    // initCategoryList(res[8]);
    // initYearList(res[9]);
    // initCityList(res[10]);
    initDifferent(res[11]);
    // initOverview(res[12]);

    setTimeout(() => { toggleLoading(false); }, 500);
  });
});

// Promise.all 前置条件
const updateRequest = action(async () => {
  console.log('触发全局条件，刷新接口请求');
  // 离职率 - 年份参数
  let year: number | string = '';
  const res: any = await HRService.dismissionYearOption();

  // 行业应届生起薪 - 年份参数
  let freshYear: number | string = '';
  let freshCategoryYear: number | string = '';
  const freshRes: any = await HRService.freshIndustryYear();

  // 城市薪酬差异系数 - 年份参数
  let cityDiffYear: number | string = '';
  const diffYearRes: any = await HRService.cityDiffYear();

  runInAction(() => {
    if (!isEmpty(res)) {
      year = res[res.length - 1];
      let tempDismissionYear = localStorage.getItem('dismissionYear') || '';

      if (tempDismissionYear) {
        moIndex.defaultDismissionYear = tempDismissionYear;
        year = tempDismissionYear;
      } else {
        moIndex.defaultDismissionYear = year;
        localStorage.setItem('dismissionYear', year.toString());
      }
      moIndex.dismissionYear = res;
      // console.log('行业离职率 时间选项 -- ', year);
    }

    if (!isEmpty(freshRes)) {
      let tempYear = localStorage.getItem('freshYear') || '';
      let tempCategoryYear = localStorage.getItem('freshCategoryYear') || '';
      moIndex.freshYearList = freshRes;
      if (tempYear) {
        freshYear = tempYear;
      } else {
        freshYear = freshRes[freshRes.length - 1];
        localStorage.setItem('freshYear', freshYear.toString());
      }
      moIndex.freshCategoryYearList = freshRes;
      if (tempCategoryYear) {
        freshCategoryYear = tempCategoryYear;
      } else {
        freshCategoryYear = freshRes[freshRes.length - 1];
        localStorage.setItem('freshCategoryYear', freshCategoryYear.toString());
      }
      // console.log('行业应届生起薪 时间选项 -- ', year);
      moIndex.freshYear = freshYear;
      moIndex.freshCategoryYear = freshCategoryYear;
    }

    if (!isEmpty(diffYearRes)) {
      let localDiffYear = localStorage.getItem('cityDiffYear') || '';
      if (localDiffYear) {
        cityDiffYear = localDiffYear;
      } else {
        let diffYear = diffYearRes[diffYearRes.length - 1];
        cityDiffYear = diffYear;
        localStorage.setItem('cityDiffYear', diffYear);
      }
      moIndex.cityDiffYear = cityDiffYear;
      moIndex.cityDiffYearList = diffYearRes;
    }

    requests(year, freshYear, freshCategoryYear, cityDiffYear);
  });
});

// 初始化 - 获取 我所属行业 和 对比的行业
const initIndex = action(async (module: number) => {
  const { isLogin } = moUser;
  // toggleValue('isLoading', false);
  await requestBase();
  const userOption = await requestUserOption();

  if (!isLogin) return;

  const res: any = await HRService.overview(moIndex.industry.name || '全行业');
  initOverview(res);

  const result: any = await Service.updateTime();
  initUpdateTime(result);

  if (!moIndex.industry.code) return;

  await Promise.all([
    getCompanyRankTime(), getCityTimeList(), getTimeListTop(),
  ])
  // 应届生起薪 时间选项
  const freshYearRes: any = await HRService.freshIndustryYear();
  let tempFreshYear: any = '2023';
  if (freshYearRes.length > 0) {
    tempFreshYear = freshYearRes[freshYearRes.length - 1];
  }
  localStorage.setItem('freshCategoryYear', tempFreshYear);

  // 城市薪酬差异系数 时间选项
  const diffYearRes: any = await HRService.cityDiffYear();
  let tempDiffYear: any = '2022';
  if (diffYearRes.length > 0) {
    tempDiffYear = diffYearRes[diffYearRes.length - 1];
  }
  localStorage.setItem('cityDiffYear', tempDiffYear);

  if (module === 1) await researchRequest();
  else if (module === 2) await updateRequest();
  else if (module === 3) await demandInit();
  else if (module === 5) {
    await talentFlowInit();
    await mobilityInit();
  }
  else if (module === 4) await welfareInit();
  const uri: any = new URI(window.location.href);
  const path: any = uri.query(true);
  setTimeout(() => {
    if (window.location.pathname.includes('human-indicator') && path.id) {
      if (path.id === '1') {
        // 涨薪率
        const distance1 = document.getElementById('indicator1')?.offsetTop || 325;
        window.scrollTo(0, distance1 + 60);
      } else if (path.id === '2') {
        // 离职率
        const distance2 = document.getElementById('indicator2')?.offsetTop || 325;
        window.scrollTo(0, distance2 + 60);
      } else if (path.id === '3') {
        // 应届生起薪
        const distance3 = document.getElementById('indicator3')?.offsetTop || 325;
        window.scrollTo(0, distance3 + 40);
      } else if (path.id === '4') {
        // 城市薪酬差异系数
        const distance4 = document.getElementById('indicator4')?.offsetTop || 325;
        window.scrollTo(0, distance4 + 60);
      } else { // 默认 id === '0'
        // 当id为0时，跳转到页面顶部
        window.scrollTo(0, 0);
      }
    }

    if (window.location.pathname.includes('human-demand') && path.id) {
      const industrys: any = document.getElementById("industry");
      const company: any = document.getElementById("company");
      const city: any = document.getElementById("city");
      const role: any = document.getElementById("role");
      const hotrole: any = document.getElementById("hotrole");
      if (path.id === "0") {
        const top = industrys.offsetTop;
        window.scrollTo(0, 0);
      }
      if (path.id === "1") {
        const top = industrys.offsetTop;
        window.scrollTo(0, top + 90);
      }
      if (path.id === "2") {
        const top = company.offsetTop;
        window.scrollTo(0, top + 90);
      }
      if (path.id === "3") {
        const top = city.offsetTop;
        window.scrollTo(0, top + 90);
      }
      if (path.id === "4") {
        const top = role.offsetTop;
        window.scrollTo(0, top + 90);
      }
      if (path.id === "5") {
        const top = hotrole.offsetTop;
        window.scrollTo(0, top + 90);
      }
    }
  }, 1000);
  // window.location.href = window.location.pathname
});

const changeDismissionYear = action(async (value: number | string) => {
  // toggleLoading(true);
  moIndex.defaultDismissionYear = value;
  localStorage.setItem('dismissionYear', value.toString());
  const res: any = await HRService.dimissionIndustry(value);
  initLeaveRate(res);

  // setTimeout(() => { toggleLoading(false) }, 500);
});

const changeFreshYear = action(async (value: number | string) => {
  // toggleLoading(true);
  moIndex.freshYear = value;
  localStorage.setItem('freshYear', value.toString());
  const res: any = await HRService.freshIndustry(value);
  initFreshSalary(res);

  // setTimeout(() => { toggleLoading(false) }, 500);
});

const changeFreshCategoryYear = action(async (value: number | string) => {
  // toggleLoading(true);
  moIndex.freshCategoryYear = value;
  localStorage.setItem('freshCategoryYear', value.toString());
  const categoryRes: any = await HRService.freshCategory(value);
  const cityRes: any = await HRService.cityFreshCategory(value);
  const yearRes: any = await HRService.yearFreshCategory();

  initCategoryList(categoryRes);
  initCityList(cityRes);
  initYearList(yearRes);

  // setTimeout(() => { toggleLoading(false) }, 500);
});

const toggleTip = action((value: boolean) => {
  moIndex.isVipTip = value;
});

// 对比的行业 - 移除行业
const unChooseIndustry = action((code: number | string) => {
  const arr: any[] = cloneDeep(moIndex.compareIndustry);
  const current: any[] = cloneDeep(moIndex.currentMulti);
  const multiArr: any[] = cloneDeep(moIndex.multiIndustry);
  const newArr: any[] = [];

  if (arr.length <= 1) return;

  arr.map((item: any) => {
    if (item.code !== code) {
      newArr.push(item);
    }
  });
  current?.map((child: any) => {
    if (child.code === code) child.active = false;
  });
  multiArr.map((item: any) => {
    item.sub_industries?.map((child: any) => {
      if (child.code === code) child.active = false;
    });
  });

  moIndex.compareIndustry = newArr;
  moIndex.currentMulti = current;
  moIndex.multiIndustry = multiArr;
});

// 对比的行业 - 选择二级行业
const chooseIndustry = action((code: number | string) => {
  const arr: any[] = cloneDeep(moIndex.currentMulti);
  const compareArr: any[] = cloneDeep(moIndex.compareIndustry);
  const multiArr: any[] = cloneDeep(moIndex.multiIndustry);

  arr.map((item: any) => {
    if (item.code === code) {
      item.active = true;
      compareArr.push(item);
    }
  });
  multiArr.map((item: any) => {
    item.sub_industries?.map((child: any) => {
      if (child.code === code) child.active = true;
    });
  });

  moIndex.currentMulti = arr;
  moIndex.compareIndustry = compareArr;
  moIndex.multiIndustry = multiArr;
});

// 对比的行业 - 选择/移除二级行业
const onChoose = action((code: number | string, active: boolean) => {
  if (active) unChooseIndustry(code);
  else chooseIndustry(code);
});

const onChoose1 = action((code: number | string, active: boolean) => {
  const arr: any[] = cloneDeep(moIndex.multiIndustry);
  let current: any[] = [];

  arr.map((item: any) => {
    if (item.info.code === code) {
      item.info.active = true;
      current = item.sub_industries || [];
    } else item.info.active = false;
  });

  moIndex.multiIndustry = arr;
  moIndex.currentMulti = current;
});

// 对比的行业 - 选择二级行业
const chooseSubIndustry = action((code: number | string) => {
  const arr: any[] = cloneDeep(moIndex.multiIndustry);

  moIndex.multiIndustry = arr;
});

// 我所属行业 - 选择行业
const chooseSingleIndustry = action(async (code: number | string, name: string) => {
  console.log('我所属行业 --- ', code);
  debugger;
  const arr: any[] = cloneDeep(moIndex.singleIndustry);

  arr.map((item: any) => {
    item.sub_industries?.map((child: any) => {
      if (child.code === code) {
        child.active = true;
      }
    });
  });

  const result: any = await HRService.editUserOption({ my_industry: name });
  if (result.code !== 0) return;

  const uri = new URI(window.location.href);
  const industryCode = uri.query(true).industryCode || '';
  const newUri = `${uri.protocol()}://${uri.hostname()}:${uri.port()}${uri.path()}`;
  if (industryCode) window.history.replaceState(null, '', newUri);

  runInAction(() => {
    moIndex.singleIndustry = arr;
    moIndex.industry = { code, name };
    moIndex.singleModal = false;

    updateRequest();
  });
});

const hoverSingle = action((code: number | string) => {
  const arr: any[] = cloneDeep(moIndex.singleIndustry);
  let currentItem: any = null;
  arr.map((item: any) => {
    if (item.info.code === code) {
      item.info.active = true;
      currentItem = item;
    } else {
      item.info.active = false;
    }
  });
  moIndex.singleIndustry = arr;
  moIndex.currentSingle = currentItem;
});

const leaveSingle = action((code: number | string) => {
  const arr: any[] = cloneDeep(moIndex.singleIndustry);
  arr.map((item: any) => {
    if (item.info.code === code) item.info.active = false;
  });
  moIndex.singleIndustry = arr;
});

const notFoundIndustry = action(() => { });

const hoverModal = action(() => { });

const leaveModal = action(() => {
  moIndex.singleModal = false;
});

const toggleSingle = action((value: boolean) => {
  moIndex.singleModal = value;
});

// 对比的行业 - 确定选择
const multiSure = action(async () => {
  let industryNames: any[] = moIndex.compareIndustry.map((item: any) => item.name);

  const result: any = await HRService.editUserOption({
    multi_industries: industryNames,
  });

  if (result.code !== 0) {
    moIndex.multiModal = false;
    return;
  }

  runInAction(() => {
    moIndex.multiModal = false;
    updateRequest();
    let module = 1;
    if (location.pathname.includes("industry-research")) module = 1;
    else if (location.pathname.includes("human-indicator")) module = 2;
    else if (location.pathname.includes("human-demand")) module = 3;
    else if (location.pathname.includes("wealfare-insight")) module = 4;
    else if (location.pathname.includes("talent-flow")) module = 5;
    initIndex(module);
  });
});

// 对比的行业 - 取消选择
const multiCancel = action(() => {
  moIndex.multiModal = false;
});

const changeMulti = action((code: number | string, active: boolean) => { });

// 对比的行业 - 触发弹框
const toggleMulti = action((value: boolean) => {
  moIndex.multiModal = value;
});

const updateDiffenence = action(async () => {
  const { cityDiffYear } = moIndex;
  const res: any = await HRService.cityDiff(cityDiffYear);
  initDifferent(res);
});

// 改变基准城市
const changeBaseCity = action(async (code: number | string, name: string) => {
  const { cityDiffYear } = moIndex;
  const arr: any[] = cloneDeep(moIndex.cityList);

  arr.map((item: any) => {
    if (item.code === code) item.active = true;
    else item.active = false;
  });

  const result: any = await HRService.editUserOption({
    standard_city: name,
  });

  if (result.code !== 0) {
    moIndex.cityModal = false;
    return;
  }

  runInAction(() => {
    moIndex.baseCity = { code, name };
    moIndex.cityList = arr;
    moIndex.cityModal = false;

    updateDiffenence();
  });
});

// 基准城市弹框
const toggleCityModal = action((value: boolean) => {
  moIndex.cityModal = value;
});

// 城市涨薪率 - 触发弹框
const toggleCityRate = action((value: boolean) => {
  moIndex.isCityRate = value;
  if (value) {
    moIndex.multiCityCopy = cloneDeep(moIndex.multiCity);
    moIndex.multiCityListCopy = cloneDeep(moIndex.multiCityList);
  }
});

const closeCityRate = action(() => {
  moIndex.isCityRate = false;
  moIndex.multiCity = moIndex.multiCityCopy;
  moIndex.multiCityList = moIndex.multiCityListCopy;
});

// 城市涨薪率 - 选择城市
const chooseCityRate = action((code: number | string) => {
  console.log('选择城市 -- ', code);
  const arr: any[] = cloneDeep(moIndex.multiCityList);
  const newArr: any[] = cloneDeep(moIndex.multiCity);

  arr.map((item: any) => {
    if (item.code === code) {
      item.active = true;
      newArr.push({ code: item.code, name: item.name });
    }
  });

  moIndex.multiCityList = arr;
  moIndex.multiCity = newArr;
});

// 城市涨薪率 - 取消选择城市
const unChooseCityRate = action((code: number | string) => {
  console.log('取消选择 -- ', code);
  const arr: any[] = cloneDeep(moIndex.multiCityList);
  const newArr: any[] = cloneDeep(moIndex.multiCity);

  arr.map((item: any) => {
    if (item.code === code) item.active = false;
  });
  for (let i = 0; i < newArr.length; i += 1) {
    if (newArr[i].code === code) newArr.splice(i, 1);
  }

  moIndex.multiCityList = arr;
  moIndex.multiCity = newArr;
});

// 城市涨薪率 - 确定
const sureCityRate = action(async () => {
  const cityNames: any[] = moIndex.multiCity.map((item: any) => item.name);
  const result: any = await HRService.editUserOption({
    multi_cities: cityNames,
  });

  runInAction(() => {
    if (result.code !== 0) {
      moIndex.isCityRate = false;
      return;
    }

    moIndex.isCityRate = false;

    HRService.upRateCity().then((res: any) => {
      initCityRate(res);
    });
  });
});

// 城市涨薪率 - 改变城市选择
const changeCityRate = action((code: number | string, active: boolean) => {
  if (!active) chooseCityRate(code);
  else unChooseCityRate(code);
});

const toggleCategoryCityModal = action((value: boolean) => {
  moIndex.isCategoryCityRate = value;
});

const updateCategoryList = action(async () => {
  const yearRes: any = await HRService.freshIndustryYear();
  let year: number | string = '';

  if (!isEmpty(yearRes)) {
    year = yearRes[yearRes.length - 1];

    changeFreshCategoryYear(year);
  }
});

const updateCategory = action(async () => {
  const cityNames: any[] = moIndex.categoryCity.map((item: any) => item.name);
  const result: any = await HRService.editUserOption({
    multi_cities: cityNames,
  });

  runInAction(() => {
    if (result.code !== 0) {
      moIndex.isCategoryCityRate = false;
      return;
    }

    moIndex.isCategoryCityRate = false;

    updateCategoryList();
  });
});

const onlyUpdateCategory = action(async () => {
  const cityNames: any[] = moIndex.categoryCity.map((item: any) => item.name);
  const result: any = await HRService.editUserOption({
    multi_cities: cityNames,
  });

  updateCategoryList();
});

// 城市涨薪率 - 选择城市
const chooseCategoryCityRate = action((code: number | string) => {
  console.log('选择城市 -- ', code);
  const arr: any[] = cloneDeep(moIndex.categoryCityArr);
  const newArr: any[] = cloneDeep(moIndex.categoryCity);

  arr.map((item: any) => {
    if (item.code === code) {
      item.active = true;
      newArr.push({ code: item.code, name: item.name });
    }
  });

  moIndex.categoryCityArr = arr;
  moIndex.categoryCity = newArr;
  onlyUpdateCategory();
  // updateCategory();
});

// 城市涨薪率 - 取消选择城市
const unChooseCategoryCityRate = action((code: number | string) => {
  console.log('取消选择 -- ', code);
  const arr: any[] = cloneDeep(moIndex.categoryCityArr);
  const newArr: any[] = cloneDeep(moIndex.categoryCity);

  arr.map((item: any) => {
    if (item.code === code) item.active = false;
  });
  for (let i = 0; i < newArr.length; i += 1) {
    if (newArr[i].code === code) newArr.splice(i, 1);
  }

  moIndex.categoryCityArr = arr;
  moIndex.categoryCity = newArr;
  onlyUpdateCategory();
  // updateCategory();
});

// 职能应届生起薪 - 改变城市选择
const changeCategoryCity = action((code: number | string, active: boolean) => {
  if (!active) chooseCategoryCityRate(code);
  else unChooseCategoryCityRate(code);
});

const sureCategoryCity = action(async () => {
  const cityNames: any[] = moIndex.categoryCity.map((item: any) => item.name);
  console.log('city names -- ', cityNames);
  updateCategory();
});

const changeCityDiffYear = action(async (value: number | string) => {
  moIndex.cityDiffYear = value;
  localStorage.setItem('cityDiffYear', value.toString());

  const res: any = await HRService.cityDiff(value);

  initDifferent(res);
});

const updateAnchor = action(() => {
  const distance1 = document.getElementById('indicator1')?.offsetTop || 325;
  const distance2 = document.getElementById('indicator2')?.offsetTop || 325;
  const distance3 = document.getElementById('indicator3')?.offsetTop || 325;
  const distance4 = document.getElementById('indicator4')?.offsetTop || 325;
});

const changeHidden = action((value: boolean) => {
  moIndex.isHidden = value;
});

// 导出PDF
const onExport = action(() => {
  if (moUser.isIndicatorExpired) {
    toggleTip(true);
    return;
  }
  posthog.capture('生成白皮书按钮', {});
  const token = Cookies.get('access_token') || '';
  const cityDiffYear = moIndex.cityDiffYear || localStorage.getItem('cityDiffYear') || '2022';
  const freshYear = moIndex.freshYear || localStorage.getItem('freshCategoryYear') || '2023';

  const data: any = {
    baseIndustry: moIndex.industry.name,
    freshYear,
    cityDiffYear,
    access_token: token,
    x: moHotRole.Xvlaue,
    y: moHotRole.Yvlaue,
    cityTime: moCity.activeTime,
    companyTime: moCompany.activeRankTime,
    hotRoleTime: moHotRole.quantityActive,
    // type:'export',
  };
  const encodeData = encodeURIComponent(JSON.stringify(data));
  const uri = `/index-pdf?data=${encodeData}&project=smart-web-home&name=人力核心指标_${moIndex.industry.name}行业报告`;
  window.open(uri);
});

export default moIndex;
export {
  initIndex, toggleTip, notFoundIndustry,
  chooseIndustry, chooseSubIndustry, unChooseIndustry,
  chooseSingleIndustry, hoverSingle, leaveSingle,
  hoverModal, leaveModal, toggleSingle, onChoose,
  multiSure, multiCancel, changeMulti, toggleMulti,
  onChoose1, changeBaseCity, toggleCityModal,
  chooseCityRate, unChooseCityRate, toggleCityRate,
  sureCityRate, changeCityRate, closeCityRate,
  updateRequest, changeDismissionYear, changeFreshYear,
  changeFreshCategoryYear, changeCategoryCity, sureCategoryCity,
  toggleCategoryCityModal, changeCityDiffYear,
  researchRequest, updateAnchor, changeHidden, onExport,
};
